import { Link, useNavigate, useLocation } from "react-router-dom";
import { LogOut, LayoutGrid, Users } from "lucide-react";
import { useAuth } from "@/context/AuthContext";

export function StaffShell({ children }) {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const loc = useLocation();

  return (
    <div style={{ minHeight: "100vh", background: "var(--off-white)", display: "flex" }}>
      <aside style={{ width: 240, borderRight: "1px solid var(--line)", background: "var(--bg-elevated)", display: "flex", flexDirection: "column", flexShrink: 0 }} className="dai-sidebar">
        <Link to="/painel" style={{ height: 68, display: "flex", alignItems: "center", padding: "0 24px", borderBottom: "1px solid var(--line)" }}>
          <img src="/brand/logo-horizontal-header-clean.png" alt="D.A.I." style={{ height: 34 }} />
        </Link>
        <nav style={{ flex: 1, padding: 16, display: "flex", flexDirection: "column", gap: 4 }}>
          <NavItem to="/painel" active={loc.pathname === "/painel"} icon={LayoutGrid} label="Pipeline" />
          <div style={{ padding: "10px 14px", color: "var(--silver-mid)", display: "flex", alignItems: "center", gap: 12, fontSize: 13 }}>
            <Users size={18} /> Clientes
          </div>
        </nav>
        <div style={{ padding: 16, borderTop: "1px solid var(--line)" }}>
          <div style={{ padding: "0 14px 12px" }}>
            <p style={{ fontSize: 14, color: "var(--navy)", margin: 0, fontWeight: 500 }}>{user?.name}</p>
            <p style={{ fontSize: 11, color: "var(--silver-mid)", margin: 0, textTransform: "capitalize", letterSpacing: "0.1em" }}>{user?.role}</p>
          </div>
          <button onClick={() => { logout(); navigate("/entrar"); }} data-testid="logout-btn"
            style={{ width: "100%", display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", background: "transparent", border: 0, color: "var(--silver-dark)", cursor: "pointer", fontSize: 13, borderRadius: 2 }}>
            <LogOut size={18} /> Sair
          </button>
        </div>
      </aside>
      <main style={{ flex: 1, overflowX: "hidden" }}>{children}</main>
    </div>
  );
}

function NavItem({ to, active, icon: Icon, label }) {
  return (
    <Link to={to} style={{ display: "flex", alignItems: "center", gap: 12, padding: "10px 14px", borderRadius: 2, fontSize: 13, textDecoration: "none",
      background: active ? "var(--navy)" : "transparent", color: active ? "var(--off-white)" : "var(--silver-dark)" }}>
      <Icon size={18} /> {label}
    </Link>
  );
}
